import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PortalMode } from './usePortalModeStore';

export const DEFAULT_PRIMARY_COLORS: Record<PortalMode, string> = {
    staff: 'blue',
    student: 'blue',
    parent: 'blue',
};

type ThemeState = {
    primaryColor: string;
    isPrimaryColorCustomized: boolean;
    setPrimaryColor: (color: string) => void;
    resetPrimaryColor: (mode: PortalMode) => void;
};

export const usePrimaryColorStore = create<ThemeState>()(
    persist(
        (set) => ({
            primaryColor: DEFAULT_PRIMARY_COLORS.staff,
            isPrimaryColorCustomized: false,
            setPrimaryColor: (color) => set({
                primaryColor: color,
                isPrimaryColorCustomized: true,
            }),
            resetPrimaryColor: (mode) => set({
                primaryColor: DEFAULT_PRIMARY_COLORS[mode],
                isPrimaryColorCustomized: false,
            }),
        }),
        { name: 'app-theme' }
    )
);
